import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardWrapper = 
styled(Grid)<{ $isActive: boolean, $isComplete: boolean }>(({ theme, $isActive, $isComplete }) => ({
  cursor: "pointer",
  backgroundColor: theme.customColors.backgroundPrimaryControl,
  border: "1px solid transparent",
  borderRadius: theme.spacing(1),
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  width: "100%",
  ...$isComplete && {
    border: `1px solid ${theme.customColors.borderSecondaryComplete}`
  },
  ...$isActive && {
    border: `1px solid ${theme.customColors.accentVariantA}`
  },
  ...!$isActive && {
    "&:hover": {
      border: `1px solid ${theme.customColors.borderAccent}`
    }
  },
  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5)
  }
}));

export const StepIndicator = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexShrink: 0,
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "start"
  }
}));
export const StatusBox = styled(Box)(({ theme }) => ({
  display:"flex",
  flexDirection:"row",
  flexWrap:"wrap",
  gap: "0.5rem",
  [theme.breakpoints.down("sm")]: {
    width: "100%"
  }
}));

export const CardContent = styled(Grid)<{ isStart?: boolean }>(({ theme, isStart }) => ({
  alignItems: isStart ? "flex-start":"flex-end",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: theme.spacing(0.5),
  height: "auto"
}));


export const TitleRow = styled(Box)(() => ({
  alignItems: "flex-start",
  display: "flex",
  justifyContent: "space-between",
  width: "100%"
}));

export const TitleTypography = styled(Typography)(() => ({
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "1.25rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}));

export const SubtitleTypography = styled(Typography)(() => ({
  fontSize: "0.75rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}));

export const MetadataRow = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem"
}));

export const CtaContainer = styled(Grid)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexShrink: 0,
  flexWrap: "nowrap",
  gap: theme.spacing(1),
  justifyContent: "flex-end",

  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap",
    width: "100%"
  }
}));
